import { Action } from 'redux';

import { SitesAndTenantsInfoRequest, SitesAndTenantsInfoRequestSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ISitesAndTenantsInfo } from '../serverApi/types/ISitesAndTenantsInfo';



export interface SitesAndTenantsInfoRequestAction extends Action {}

export function sitesAndTenantsInfoRequest(): SitesAndTenantsInfoRequestAction {
  return {
    type: SitesAndTenantsInfoRequest
  };
}

export const isSitesAndTenantsInfoRequestAction = isActionFactory<SitesAndTenantsInfoRequestAction>(SitesAndTenantsInfoRequest);



export interface SitesAndTenantsInfoRequestSucceededAction extends Action {
  readonly sitesAndTenantsInfo: ISitesAndTenantsInfo;
}

export function sitesAndTenantsInfoRequestSucceeded(sitesAndTenantsInfo: ISitesAndTenantsInfo): SitesAndTenantsInfoRequestSucceededAction {
  return {
    type: SitesAndTenantsInfoRequestSucceeded,
    sitesAndTenantsInfo
  };
}

export const isSitesAndTenantsInfoRequestSucceededAction = isActionFactory<SitesAndTenantsInfoRequestSucceededAction>(SitesAndTenantsInfoRequestSucceeded);
